import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminRoutingModule } from "./admin-routing.module";
import { AdminLayoutComponent } from "./components/theme/admin-layout/admin-layout.component";
import { AdminLoginComponent } from "./components/account/admin-login/admin-login.component";
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTypeaheadModule,
} from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LookupService } from "../services/LookupService";
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedModule } from "../shared/shared.module";
import { FranchiseAdminDetailsComponent } from "./components/franchise/franchise-admin-details/franchise-admin-details.component";
import { AttachmentService } from "../services/AttachmentService";
import { AccountServiceService } from "../services/AccountService";
import { ViolatedSectionComponent } from "./components/franchise/franchise-admin-details/components/violated-section/violated-section.component";
import { SuspendedSectionComponent } from "./components/franchise/franchise-admin-details/components/suspended-section/suspended-section.component";
import { CancelledSectionComponent } from "./components/franchise/franchise-admin-details/components/cancelled-section/cancelled-section.component";
import { UserListComponent } from "./components/user-management/user-list/user-list.component";
import { CreateOrEditUserComponent } from "./components/user-management/create-or-edit-user/create-or-edit-user.component";
import { UserManagementService } from "./services/user-management.service";
import { UserFilterComponent } from "./components/user-management/user-filter/user-filter.component";
import { EmailActivationComponent } from "./components/account/email-activation/email-activation.component";
import { ChangePasswordComponent } from "./components/account/change-password/change-password.component";
import { ForgotPasswordComponent } from "./components/account/forgot-password/forgot-password.component";
import { SidebarComponent } from "./components/theme/sidebar/sidebar.component";
import { FilterComponent } from "./components/franchise/filter/filter.component";
import { FranchisesAdminListComponent } from "./components/franchise/franchise-admin-list/franchise-admin-list.component";
import { FranchiseAdminTabComponent } from "./components/franchise/franchise-admin-tab/franchise-admin-tab.component";
import { FranchiseActionsModalComponent } from "./components/franchise/franchise-actions-modal/franchise-actions-modal.component";
import { ReasonListComponent } from "./components/reasons/reason-list/reason-list.component";
import { CreateEditReasonComponent } from "./components/reasons/create-edit-reason/create-edit-reason.component";
import { ReasonTabComponent } from "./components/reasons/reason-tab/reason-tab.component";
import { ReasonService } from "./services/reason.service";
import { StorageService } from "./services/storage.services";
import { FranchiseRaiseActionsModalComponent } from './components/franchise/franchise-actions-modal/franchise-raise-actions-modal/franchise-raise-actions-modal.component';
import { TwoFactorAuthComponent } from './components/account/two-factor-auth/two-factor-auth.component';
import { DonorRequestAdminListComponent } from './components/request/donor-request-admin-list/donor-request-admin-list.component';
import { DonorRequestAdminFilterComponent } from './components/request/donor-request-admin-filter/donor-request-admin-filter.component';

@NgModule({
  declarations: [
    AdminLayoutComponent,
    AdminLoginComponent,
    SidebarComponent,
    FilterComponent,
    FranchiseAdminDetailsComponent,
    FranchisesAdminListComponent,
    FranchiseAdminTabComponent,
    FranchiseActionsModalComponent,
    ViolatedSectionComponent,
    SuspendedSectionComponent,
    CancelledSectionComponent,
    UserListComponent,
    CreateOrEditUserComponent,
    UserFilterComponent,
    EmailActivationComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    ReasonListComponent,
    CreateEditReasonComponent,
    ReasonTabComponent,
    FranchiseRaiseActionsModalComponent,
    TwoFactorAuthComponent,
    DonorRequestAdminListComponent,
    DonorRequestAdminFilterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbDatepickerModule,
    NgSelectModule,
  ],
  providers: [
    LookupService,
    AttachmentService,
    AccountServiceService,
    UserManagementService,
    ReasonService,
    StorageService
  ],
})
export class AdminModule {}
